import { LayoutDashboard, Calendar, FileText, BarChart3, Settings, Receipt, Scale, Zap, Palmtree, BookOpen, MessagesSquare, type LucideIcon } from 'lucide-react';

export type NavItem = { to: string; label: string; icon: LucideIcon };

/** Navigatie, gegroepeerd naar waar je het voor gebruikt. Eén bron voor zijbalk en onderbalk. */
export const NAV_GROUPS: Array<{ title: string; items: NavItem[] }> = [
  {
    title: 'Werk',
    items: [
      { to: '/', label: 'Overzicht', icon: LayoutDashboard },
      { to: '/kalender', label: 'Kalender', icon: Calendar },
      { to: '/verlof', label: 'Verlof', icon: Palmtree },
      { to: '/vragen', label: 'Vragen', icon: MessagesSquare },
    ],
  },
  {
    title: 'Loon',
    items: [
      { to: '/afwijkingen', label: 'Loon controleren', icon: Scale },
      { to: '/statistieken', label: 'Statistieken', icon: BarChart3 },
      { to: '/onkosten', label: 'Onkosten', icon: Receipt },
    ],
  },
  {
    title: 'Beheer',
    items: [
      { to: '/acties', label: 'Acties', icon: Zap },
      { to: '/regels', label: 'Regels en cijfers', icon: BookOpen },
      { to: '/documenten', label: 'Documenten', icon: FileText },
      { to: '/instellingen', label: 'Instellingen', icon: Settings },
    ],
  },
];
